import axios from 'axios';

export const getOpeningHours = async () => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_API_HOST}/openinghours`);
        return response.data;
    } catch (error) {
        console.error('Error fetching opening hours:', error);
        console.error('Error details:', error.response?.data || error.message);
        return { ok: false, message: 'Error fetching opening hours', error: error.message };
    }
};

